import { Service } from "@catalogue/domain/models/service.model";
import { ServiceFormValuesValidated } from "@catalogue/presentation/components/service/service-form.component";
import { injectable } from "inversify";

@injectable()
export class CreateServiceMapper {
    mapFromForm(values: ServiceFormValuesValidated): Omit<Service, "id"> {
        return {
            category: values.category,
            entity: values.entity,
            createdAt: new Date().toISOString(),
        };
    }
}
